export default "__VITE_ASSET__OGoLaNkA__"